// web/src/components/ds/DsIconButton.tsx — DS.5 (sprint aos-ds-shell, spec §2 D6b).
//
// `@ds/actions/IconButton` with its Material ripple suppressed — the ONE
// reason this adapter exists. The ripple is motion the founder never saw on
// an approved mockup (D2: the PNG is the authority) and the rule that used to
// forbid it (`cursor-ux-mirror.md` §2.5) was retired by DS.4 without a
// replacement; this records the decision instead of patching the vendored
// piece (D-1084's 3-file threshold — an upstream PR if ever wanted). The
// suppression is one CSS rule in ds-adapters.css keyed on the class below.
// Everything else — variant, size, `aria-label` (required by the piece),
// `disabled`, `data-testid`, `title`, `ref` — passes straight through.

import { forwardRef, type ComponentProps } from 'react';
import IconButton from '@ds/actions/IconButton';
import './ds-adapters.css';

export type DsIconButtonProps = ComponentProps<typeof IconButton>;

export const DsIconButton = forwardRef<HTMLButtonElement, DsIconButtonProps>(
  ({ className = '', ...props }, ref) => (
    <IconButton ref={ref} className={`aos-ds-icon-button ${className}`.trim()} {...props} />
  ),
);
DsIconButton.displayName = 'DsIconButton';

export default DsIconButton;
